// Languages card on the dashboard (LeetCode shows "solved per language";
// here the count is a rough measure of how much I reach for each language).
export const languages = [
  { name: "JavaScript", count: 9 },
  { name: "TypeScript", count: 4 },
  { name: "Java", count: 4 },
  { name: "Python", count: 4 },
  { name: "SQL", count: 3 },
  { name: "C++", count: 2 },
];

// LeetCode-style skill tiers (Advanced / Intermediate / Fundamental).
export const skillTiers = {
  Advanced: [
    "Java",
    "Spring Boot",
    "React",
    "Node.js",
    "Express.js",
    "TypeScript",
    "PostgreSQL",
    "Docker",
  ],
  Intermediate: [
    "Next.js",
    "Redux",
    "MongoDB",
    "Prisma",
    "Kafka",
    "Redis",
    "AWS",
    "Azure",
    "GraphQL",
    "FastAPI",
  ],
  Fundamental: [
    "JavaScript",
    "C++",
    "Python",
    "SQL",
    "HTML5",
    "CSS3",
    "Git",
    "Linux",
  ],
};

// Full "Topics" (tags) page — every tech & tool, grouped by category.
export const topicCategories = [
  {
    name: "Languages",
    items: ["Java", "C++", "Python", "JavaScript", "TypeScript", "SQL", "HTML5", "CSS3"],
  },
  {
    name: "Frontend",
    items: ["React", "Next.js", "Redux", "TypeScript", "Tailwind CSS", "Bootstrap", "MUI"],
  },
  {
    name: "Backend",
    items: ["Node.js", "Express.js", "Spring Boot", "Flask", "FastAPI", "Prisma", "Sequelize", "GraphQL"],
  },
  {
    name: "Databases",
    items: ["PostgreSQL", "MongoDB", "MySQL", "Couchbase", "Redis"],
  },
  {
    name: "Cloud & DevOps",
    items: [
      "AWS",
      "Azure",
      "Docker",
      "Podman",
      "Jenkins",
      "GitLab CI/CD",
      "GitHub Actions",
      "OpenShift",
      "nginx",
      "Netlify",
      "Vercel",
    ],
  },
  {
    name: "AI / GenAI",
    items: ["RAG", "Vector Search", "MCP", "LLM Integration", "FastAPI"],
  },
  {
    name: "Concepts",
    items: [
      "System Design",
      "Microservices",
      "REST APIs",
      "RBAC / ABAC",
      "OAuth / JWT",
      "Azure AD SSO",
      "Kafka",
      "Swagger",
    ],
  },
  {
    name: "ML, CV & IoT",
    items: ["OpenCV", "Machine Learning", "ESP32", "Raspberry Pi", "Arduino", "IFTTT", "Webhooks"],
  },
  {
    name: "Tools",
    items: ["Git", "GitHub", "Linux", "VS Code", "IntelliJ IDEA", "PyCharm", "DBeaver", "Postman"],
  },
];

export const totalTopics = topicCategories.reduce(
  (n, c) => n + c.items.length,
  0
);

export default topicCategories;
